module.exports = __webpack_public_path__ + "img/es-ont.07371f15.svg";